import { Button, Col, Row, Tooltip } from "antd";
import { FaBan, FaCheck, FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { IconType } from "react-icons";
import { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";

export enum EActionType {
    EDIT = "edit",
    DELETE = "delete",
    DISABLE = "disable",
    ENABLE = "enable",
    VIEW = "view",
}

interface IAction {
    type?: EActionType | ((record: any) => EActionType);
    onPress: (record: any) => void;
    icon?: IconType;
    label?: string;
    color?: string;
    danger?: boolean;
    loading?: boolean;
    disabled?: boolean | ((record: any) => boolean);
    hidden?: boolean | ((record: any) => boolean);
}

interface IProps {
    showLabels?: boolean;
    actions: IAction[];
}

const ACTION_CONFIG: Record<EActionType, {
    icon: IconType;
    label: string;
    color?: string;
    danger?: boolean;
}> = {
    [EActionType.EDIT]: {
        icon: FaEdit,
        color: '#1890ff',
        label: "Editar",
    },
    [EActionType.DELETE]: {
        icon: FaTrash,
        label: "Deletar",
        color: "#ff4d4f",
        danger: true
    },
    [EActionType.DISABLE]: {
        icon: FaBan,
        label: "Inativar",
        color: "#ff4d4f",
        danger: true
    },
    [EActionType.ENABLE]: {
        icon: FaCheck,
        color: "#328E6E",
        label: "Ativar",
    },
    [EActionType.VIEW]: {
        icon: FaEye,
        color: "#1890ff",
        label: "Visualizar",
    },
};

export const useActionsTable = ({ showLabels = false, actions }: IProps) => {
    const { theme } = useContext(ThemeContext);

    const colorDisabled = theme === 'dark' ? '#222' : '#ccc';

    return {
        render: (_: any, record: any) => (
            <Row gutter={[12, 12]}>
                {actions.map((action, index) => {
                    const actionType = typeof action.type === "function" ? action.type(record) : action.type;
                    const disabled = typeof action.disabled === "function" ? action.disabled(record) : action.disabled;
                    const hidden = typeof action.hidden === "function" ? action.hidden(record) : action.hidden;
                    const config = actionType ? ACTION_CONFIG[actionType] : undefined;
                    const IconComponent = action.icon ?? config?.icon ?? FaEye;
                    const label = action.label ?? config?.label;
                    const color = action.color ?? config?.color;
                    const danger = action.danger ?? config?.danger;

                    return (
                        <Col key={index} style={{ display: !hidden ? 'flex' : 'none' }}>
                            <Tooltip color={disabled ? colorDisabled : color} title={label}>
                                <Button
                                    type="primary"
                                    loading={action.loading}
                                    disabled={disabled}
                                    danger={danger}
                                    icon={<IconComponent />}
                                    style={{ backgroundColor: disabled ? colorDisabled : color }}
                                    onClick={() => action.onPress(record)}
                                >
                                    {showLabels && label}
                                </Button>
                            </Tooltip>
                        </Col>
                    );
                })}
            </Row>
        )
    };
};
